import React from "react";
import { Link } from "react-router-dom";
import CountdownCard from "../../../components/Countdown";
import {
	BNB,
	ChainIcon,
	Dots,
	LiquidityLockIcon,
	User,
} from "../../../IconTheme";

const ProjectCard = (props) => {
	const {
		tokenName,
		logo,
		staus,
		audit,
		kyc,
		chain,
		liquidityLock,
		userWhitelist,
		totalWhitelist,
		reservedUsers,
		totalReservations,
		softcap,
		hardcap,
		description,
		round,
		countDown,
		totalSold,
		progressBAr,
	} = props;

	return (
		<div className="token-card">
			<div className="token-card-top-area">
				<div className="token-card-top">
					<span>
						<Dots status={kyc} /> Kyc
					</span>
					<span>
						<Dots status={audit} /> Audit
					</span>
					{staus === "live" && <span className="active">Active</span>}
				</div>
				<div className="token-card-middle">
					<div className="img">
						<img src={logo} alt="" />
						<span className="badge">
							<BNB /> <span>{chain}</span>
						</span>
					</div>
					<div className="cont">
						<h5 className="subtitle">
							<Link to="#">{tokenName}</Link>
						</h5>
						<div className="info-grp">
							<span className="badge">
								<ChainIcon /> <span>{chain}</span>
							</span>
							<span className="badge">
								<LiquidityLockIcon />
								<span>{liquidityLock}</span>
							</span>
							<span className="badge">
								<LiquidityLockIcon />
								<span>{reservedUsers + "/" + totalReservations}</span>
							</span>
							<span className="badge">
								<User />
								<span>{userWhitelist + "/" + totalWhitelist}</span>
							</span>
						</div>
					</div>
				</div>
				<div className="description">{description && description}</div>
			</div>
			<ul className="info">
				<li>
					<span>Softcap:</span>
					<span>{softcap} USDT</span>
				</li>
				<li>
					<span>Hardcap:</span>
					<span>{hardcap} USDT</span>
				</li>
				<li>
					<span>Liquidity:</span>
					<span>{liquidityLock}</span>
				</li>
			</ul>
			<div className="token-card-bottom">
				<div className="d-flex justify-content-between align-items-center">
					<span>{round}</span>
					<CountdownCard targetDate={`January 31, 2024 00:00:00`} />
				</div>
				<div className="progress __progress">
					<div
						className="progress-inner"
						style={{ width: `${progressBAr}%` }}
					></div>
				</div>
				<div className="d-flex justify-content-between align-items-center">
					<span>14 BNB</span>
					<span>25 BNB</span>
				</div>
			</div>
		</div>
	);
};

export default ProjectCard;
